import React, { FC, forwardRef } from 'react';
import './CustomDatepickerField.scss';
import FieldInput from '../../../../../../../components/ui/forms/fields/FieldInput/FieldInput';
import { useTranslation } from "react-i18next";

interface Props {
    start: string;
    end: string;
    onClickStart: (e: any) => void;
    onClickEnd: (e: any) => void;
}

const CustomDatepickerField: FC<Props> = forwardRef((props, ref) => {
    const {start, end, onClickStart, onClickEnd} = props;
    const [t] = useTranslation();

    return (
        <div className="hotel-rooms-custom-date-pickers">
            <div className="hotel-rooms-custom-date-pickers__item">
                <div>
                    <label className="hotel-rooms-custom-date-pickers__label" htmlFor="checkin-date">
                        {t("Заїзд")}
                    </label>

                    <div className="hotel-rooms-custom-date-pickers__input" onClick={onClickStart}>
                        {/*  @ts-ignore */}
                        <FieldInput
                            size="large"
                            value={start}
                            style={{zIndex: -1}}
                            readOnly
                            ref={ref}
                            id="checkin-date"

                            placeholder={t("День заїзду")}
                        />
                    </div>
                </div>
            </div>

            <div className="hotel-rooms-custom-date-pickers__item">
                <div>
                    <label className="hotel-rooms-custom-date-pickers__label" htmlFor="checkout-date">
                        {t("Виїзд")}
                    </label>

                    <div className="hotel-rooms-custom-date-pickers__input" onClick={onClickEnd}>
                        {/*  @ts-ignore */}
                        <FieldInput
                            size="large"
                            style={{zIndex: -1}}
                            value={end}
                            readOnly
                            ref={ref}
                            disabled
                            id="checkout-date"
                            placeholder={t("День виїзду")}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
});

export default CustomDatepickerField;
